export default __webpack_public_path__ + "static/media/home-freelancer-img-03.7ee6020d.png";